import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import images from "../../../assets/images";
import { useGlobalState } from "../../../MeetContext/MeetContext";
import { useAppSelector } from "../../../redux/app/hooks";
import { useChimeMeeting } from "../../../Chime/ChimeMeetingContext";
import { useLazyQuery } from "@apollo/client";
import {
  GET_UNREAD_MESSAGES_COUNT_FOR_VIDEO_MEET,
  GET_VIDEO_MEET_CHAT_ROOM,
} from "../../../Chime/helpers/ChatApi/ChatQuery";
import { useLocation } from "react-router-dom";
import { InitialiseChatConnection } from "../../../websocket/ChatWebSocket";
import { getInitials } from "../../../utils/webRTCHelper";
import { ChatMessage } from "./types/MeetingChat.types";
import { useChimeMeetingChat } from "../../../hooks/useChimeMeetingChat";

const MobileChat = ({ propChatRoomId }: { propChatRoomId?: string }) => {
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const userName = profile?.getCurrentUser?.nodes[0]?.uFullName;
  const userId = profile?.getCurrentUser?.nodes?.[0]?.uUserName;
  const [chatRoomId, setChatRoomId] = useState("");
  const { attendeeId } = useChimeMeeting();
  const [text, setText] = useState("");
  const messageEndRef = useRef<HTMLDivElement>(null);
  const { sendMessageIcon } = images;
  const [chatMessages, setChatMessages] = useState<ChatMessage[]>([]);
  const [isChatOpen, setIsChatOpen] = useState(true);

  const { sendMessage } = useChimeMeetingChat(setChatMessages);

  useEffect(() => {
    if (propChatRoomId) {
      setChatRoomId(propChatRoomId);
    }
  }, [propChatRoomId])

  const [getVideoMeetChatRoom] = useLazyQuery(GET_VIDEO_MEET_CHAT_ROOM, {
    fetchPolicy: "network-only",
    onCompleted: async (data) => {
      if (data?.allVideoMeetChats?.nodes[0]?.chatroomId) { 
        setChatRoomId(data?.allVideoMeetChats?.nodes[0]?.chatroomId);
      }
    },
    onError: (err: any) => {
      console.log("-----------err---------------------", err);
    },
  });
  const location = useLocation();

  // useEffect(() => {
  //   console.log("[chatroomId] useEffect", location?.state?.sessionId);
  //   if (location?.state?.sessionId) {
  //     getVideoMeetChatRoom({
  //       variables: {
  //         meetId: location?.state?.sessionId,
  //       },
  //     });
  //   }
  // }, [attendeeId]);

  const handleSendMessage = () => {
    sendMessage(text);
    setText("");
  };

  useEffect(() => {
    if (messageEndRef.current) {
        messageEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
}, [chatMessages]);

  return (
    <>
      <div style={messageListWrapperStyle}>
        <div style={messageContainerStyle}>
          {chatMessages && chatMessages.length > 0 ? (
            chatMessages.map((message, index) => (
              <div key={index} style={messageItemStyle}>
                <div
                  style={{
                    fontSize: 24,
                    color: "black",
                    fontWeight: "bold",
                    background: "#ccf2f9",
                    width: 50,
                    height: 50,
                    borderRadius: 50,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {getInitials(message.name)}
                </div>
                <div>
                <div style={messageDisplayNameStyle}>{message.name}</div>
                <div style={messageTextStyle}>{message.message}</div>
                </div>
              </div>
            ))
          ) : (
          null
          )}
          <div ref={messageEndRef} />
        </div>
      </div>
      <div style={messageInputWrapperStyle}>
        <div style={containerStyle}>
          <input
            type="text"
            style={inputStyle}
            placeholder="Say Something..."
            onChange={(val) => setText(val.target.value)}
            value={text}
          />
          <img
            src={sendMessageIcon}
            style={iconStyle}
            onClick={handleSendMessage}
          />
        </div>
      </div>
    </>
  );
};

const messageListWrapperStyle: any = {
  display: "flex",
  justifyContent: "center",
};

const messageContainerStyle: any = {
  width: "90%",
  position: "absolute",
  bottom: 188,
  alignItems: "center",
  minHeight: "0%",
  maxHeight: "20%",
  overflowY: "auto",
  overflowX: "hidden",
  paddingRight: 10,
  borderRadius: "10px",
  paddingBottom: "20px",
  zIndex: 2,
};

const messageItemStyle: any = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 10,
  marginTop: 5,
};

const messageDisplayNameStyle: any = {
  fontSize: 12,
  fontWeight: "bold",
  color: "white",
  textShadow: "rgba(0, 0, 0, 0.6) 0px 1px 2px, rgba(0, 0, 0, 0.3) 0px 0px 2px"
};

const messageTextStyle: any = {
  fontSize: 12,
  color: "white",
  opacity: 0.9,
  textShadow: "rgba(0, 0, 0, 0.6) 0px 1px 1px, rgba(0, 0, 0, 0.3) 0px 0px 1px"
};

const messageInputWrapperStyle: any = {
  display: "flex",
  justifyContent: "center",
};

const containerStyle: any = {
  width: "90%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  position: "absolute",
  bottom: 130,
  alignItems: "center",
  zIndex: 999,
};

const inputStyle: any = {
  height: 44,
  width: "100%",
  borderRadius: 10,
  borderColor: "white",
  paddingLeft: 10,
  background: "transparent",
  color: "white",
  flex: 1,
};

const iconStyle: any = {
  marginLeft: 10,
  cursor: "pointer",
  filter: "drop-shadow(2px 2px 1px grey)",
};

export default MobileChat;
